module.exports = __webpack_public_path__ + "img/jardimmx_01.3429fccd.jpg";